import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=4714e97e"
import script from "./CardItem.vue?vue&type=script&lang=ts"
export * from "./CardItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4714e97e')) {
      api.createRecord('4714e97e', component.options)
    } else {
      api.reload('4714e97e', component.options)
    }
    module.hot.accept("./CardItem.vue?vue&type=template&id=4714e97e", function () {
      api.rerender('4714e97e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/common/CardItem.vue"
export default component.exports